import filters from './filters.coffee'

class DemographicsUtility

  @getAll: ->
    gender: [
      'female'
      'male'
    ]
    race: [
      'amerindian'
      'asian'
      'black'
      'hispanic'
      'white'
      'two_or_more_races'
      'other_race'
    ]
    age: [
      'age_18_29'
      'age_30_39'
      'age_40_49'
      'age_50_59'
      'age_60_69'
      'age_70_79'
      'age_over_80'
    ]
    income: [
      'income_less_than_24999'
      'income_25000_49999'
      'income_50000_74999'
      'income_75000_99999'
      'income_100000_124999'
      'income_more_than_125000'
    ]
    education: [
      'high_school_diploma'
      'associates_degree'
      'some_college_no_degree'
      'bachelors_degree'
      'masters_degree'
    ]

  @labelForGroup: (key) ->
    customLabels =
      race: 'Ethnicity'
    customLabels[key] || filters.formatTitle(key)

export default DemographicsUtility
